import { render, staticRenderFns } from "./FileInputSlot.vue?vue&type=template&id=1035c97e"
import script from "./FileInputSlot.vue?vue&type=script&lang=js"
export * from "./FileInputSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports